module.exports = __webpack_public_path__ + "static/media/img2-1.3a7310ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/agave/nutricheck_foliar/FE/img2-1.png
// module id = 1043
// module chunks = 3